var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "award-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.0833 38.983V56.8332L30.2325 51.9735C30.516 51.8601 30.6578 51.8034 30.8042 51.7809C30.934 51.761 31.066 51.761 31.1958 51.7809C31.3422 51.8034 31.484 51.8601 31.7675 51.9735L43.9167 56.8332V38.983M50.375 24.5415C50.375 35.242 41.7005 43.9165 31 43.9165C20.2995 43.9165 11.625 35.242 11.625 24.5415C11.625 13.841 20.2995 5.1665 31 5.1665C41.7005 5.1665 50.375 13.841 50.375 24.5415Z",
    stroke: "#45C49E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon2);
export default __webpack_public_path__ + "static/media/videoIcon2.aa7b371d6ef9c0adddfc85862d4d586e.svg";
export { ForwardRef as ReactComponent };